import { gql } from "graphql-tag";

export const GET_USERS = gql`
  query GetUsers($pagination: PaginationInput, $sort: UserSortInput, $filter: UsersFilterInput) {
    users(pagination: $pagination, sort: $sort, filter: $filter) {
      data {
        id
        firstName
        lastName
        email
        emailVerified
        role
        isActive
        account {
          id
          name
        }
        locationIds
        assignedLocations {
          id
          name
        }
        createdAt
        updatedAt
      }
      meta {
        page
        limit
        total
        totalPages
        hasNext
        hasPrev
      }
    }
  }
`;

export const GET_USER = gql`
  query GetUser($id: ID!) {
    user(id: $id) {
      id
      firstName
      lastName
      email
      emailVerified
      role
      isActive
      accountId
      contactId
      avatarFileKey
      warehouseIds
      queueIds
      primaryQueueId
      locationCategoryIds
      locationIds
      queues {
        id
        name
      }
      locationCategories {
        id
        name
        color
      }
      assignedLocations {
        id
        name
      }
      accessibleLocations {
        id
        name
      }
      warehouses {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`;
